module.exports = __webpack_public_path__ + "img/63.3161714a.jpg";